import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/cluster/inputstates", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setup(inputId, requestOptions) {
  return __request__("PUT", `/cluster/inputstates/setup/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function start(inputId, requestOptions) {
  return __request__("PUT", `/cluster/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function stop(inputId, requestOptions) {
  return __request__("DELETE", `/cluster/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
